import React from "react";
import PropTypes from "prop-types";

function DashboardPage({ children }) {
  DashboardPage.propTypes = {
    children: PropTypes.any.isRequired,
  };
  return <div className=" mb-[8px]">{children}</div>;
}

export default DashboardPage;
